export class AuthError extends Error {
  code?: string;
  constructor(code?: string, description?: string) {
    const message = typeof description === 'string' && description ? description : code || 'Authentication error';
    super(message);
    this.name = 'AuthError';
    this.code = code;
  }
}

export function isUserCancellation(e: unknown): boolean {
  const code = (e as any)?.code || '';
  const msg = (e as any)?.message || '';
  return /cancel/i.test(code) || /cancel/i.test(msg);
}

export function mapAuthError(e: unknown): string {
  const code = (e as AuthError)?.code;
  const msg = (e as Error)?.message || '';

  switch (code) {
    case 'invalid_grant':
      return 'Incorrect email or password.';
    case 'email_not_verified':
      return 'Please verify your email before logging in.';
    case 'too_many_attempts':
      return 'Too many attempts. Please wait a moment and try again.';
    case 'invalid_password':
      return msg || 'Password does not meet the requirements.';
    case 'invalid_signup':
    case 'user_exists':
      return 'An account with this email already exists.';
    case 'password_leaked':
      return 'This password has appeared in a data breach. Please choose another.';
    case 'unsupported':
      return msg;
    default:
      return msg || 'Something went wrong. Please try again.';
  }
}
